/**
 * Route paths and the role -> home mapping.
 *
 * Port of the `redirect` callback in
 * rent_management_app/lib/core/routes/app_router.dart:61-93.
 */
import type { UserRole } from '../types/user';

export const ROUTES = {
  landing: '/',
  login: '/auth/login',
  register: '/auth/register',
  publicProperties: '/public/properties',
  publicPropertiesMap: '/public/properties/map',
  landlord: '/landlord',
  agent: '/agent',
  tenant: '/tenant',
  admin: '/admin',
} as const;

/**
 * app_router.dart:84-90 — where an authenticated user belongs.
 *
 *     if (user.isLandlord || user.isSuperAgent) return '/landlord';
 *     if (user.isAgent) return '/agent';
 *     if (user.isTenant) return '/tenant';
 *     return '/landlord';
 *
 * SUPERAGENT goes to `/landlord`, not `/admin`: in the Flutter app the
 * superagent's admin surface is a TAB INSIDE the landlord shell
 * (`/landlord/users` -> UserManagementScreen, app_router.dart:207-210), not a
 * separate shell. `/admin` here is scaffolding for a future split and is
 * deliberately not the default landing spot for anyone — changing that would be
 * a product decision, not a port.
 */
export function homePathForRole(role: UserRole): string {
  switch (role) {
    case 'LANDLORD':
    case 'SUPERAGENT':
      return ROUTES.landlord;
    case 'AGENT':
      return ROUTES.agent;
    case 'TENANT':
      return ROUTES.tenant;
  }
}

/**
 * app_router.dart:65 — `state.matchedLocation.startsWith('/public')`, plus the
 * landing page at '/'. These stay reachable while logged out.
 */
export function isPublicPath(pathname: string): boolean {
  return pathname === ROUTES.landing || pathname.startsWith('/public');
}
